import React from 'react';
import { useSelector } from 'react-redux';
import Team from './Team';
import './TeamList.css';
import ColorLegend from '../planning/ColorLegend';
import * as ResourceStore from '../../store/ResourceStore';
import moment from 'moment';

const CustomTeamList = () => {
    const units = useSelector((state) => state[ResourceStore.reducerName].units); 
    const bookings = useSelector((state) => state[ResourceStore.reducerName].bookings);
    const teams = useSelector((state) => state.teamState.teams);

    const now = moment();
    const currentBookings = bookings.filter((x) => now.isSameOrAfter(moment(x.startTime)) && now.isSameOrBefore(moment(x.endTime)));

    if (teams.length < 1) return null;

    const addUnits = (team) => {
        if (!team) return;
        const unitsForTeam = currentBookings.reduce((result, b) => {
            if (b.teamId === team.id) {
                const unit = units.find((u) => u.id === b.unitId);
                if (unit) result.push(unit);
            }
            return result;
        }, []);
        return { ...team, units: unitsForTeam };
    };
    
    const administration = teams.find((x) => x.id === 21);
    addUnits(administration);

    const vejomraadet = teams.find((x) => x.id === 22);
    addUnits(vejomraadet);

    const vej = teams.find((x) => x.id === 119);
    addUnits(vej);

    const gronvej = teams.find((x) => x.id === 26);
    addUnits(gronvej);

    const komunaleEjendome = teams.find((x) => x.id === 23);
    addUnits(komunaleEjendome);

    const team2 = teams.find((x) => x.id === 28);
    addUnits(team2);

    const team3 = teams.find((x) => x.id === 29);
    addUnits(team3);

    const tvear = teams.find((x) => x.id === 30);
    addUnits(tvear);

    const vearkstedOgGenbrug = teams.find((x) => x.id === 24);
    addUnits(vearkstedOgGenbrug);

    const genbrug = teams.find((x) => x.id === 31);
    addUnits(genbrug);

    return (
        <>
            <div className="team-list">
                {administration && 
                    <Team 
                        team={administration} 
                        width={20}
                        height={41.5}
                    />
                }
                {vejomraadet && 
                    <Team 
                        team={vejomraadet} 
                        width={25} 
                        subTeams={[vej]} 
                    />
                }
                {komunaleEjendome && 
                    <Team 
                        team={komunaleEjendome} 
                        width={39} 
                        subTeams={[team2, team3]} 
                    />
                }
                {vearkstedOgGenbrug && 
                    <Team 
                        team={vearkstedOgGenbrug} 
                        width={16} 
                        subTeams={[genbrug]} 
                    />
                }
                {gronvej && 
                    <Team 
                        team={gronvej} 
                        width={20} 
                        height={81} 
                        top={-58.5}
                    />
                }
            </div>
            <ColorLegend className="team-legend" />
        </>
    );
};

export default CustomTeamList;